import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function TourAlbum2026() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            本社見学2026年
          </Typography>
          <Box my={4}>
            <Paper>
              <Grid className="p-3" spacing={4} container direction="row" justify="left">

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img261008_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          東北町立甲地小４、５年生のみなさん（2026/10/08）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img260929_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          階上町立道仏小５年生のみなさん（2026/09/29）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img260805_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          デーリー東北八戸駅前専売所のみなさん（2026/08/05）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img260612_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          五戸町立倉石小５年生のみなさん（2026/06/12）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img260303_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市・陽だまりクラブのみなさん（2026/03/03）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        maxWidth="500"
                        maxHeight="350"
                        image="/images/kengaku/2026/k_img260225_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立白銀小５年生のみなさん（2026/02/25）
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

              </Grid>
            </Paper>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default TourAlbum2026;
